import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'zone-refresh-banner',
  templateUrl: './zone-refresh-banner.component.html'
})
export class ZoneRefreshBannerComponent implements OnInit {
  @Input() link: string;

  constructor(
  ) { }

  ngOnInit() {
  }
}
